var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3292 1.00781C10.4408 1.11942 10.4967 1.24777 10.4967 1.39286C10.4967 1.53795 10.4408 1.66629 10.3292 1.7779L3.75 8.35714L10.3292 14.9364C10.4408 15.048 10.4967 15.1763 10.4967 15.3214C10.4967 15.4665 10.4408 15.5949 10.3292 15.7065L9.49219 16.5435C9.38058 16.6551 9.25223 16.7109 9.10714 16.7109C8.96205 16.7109 8.83371 16.6551 8.7221 16.5435L0.920759 8.74219C0.809152 8.63058 0.753348 8.50223 0.753348 8.35714C0.753348 8.21205 0.809152 8.0837 0.920759 7.9721L8.7221 0.170758C8.83371 0.0591503 8.96205 0.00334668 9.10714 0.00334668C9.25223 0.00334668 9.38058 0.0591503 9.49219 0.170758L10.3292 1.00781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.a4e780d827b4cb0a453dc1e56b76c63b.svg";
export { ForwardRef as ReactComponent };